module.exports = __webpack_public_path__ + "static/duplicate-4fbdf3ded3eb3ab0c1ee95569e6acb0d.mp4";